module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"title":"L\u0027équipe Peptinov","management":"Management","rd":"Equipe R&D","strategic":"Conseil stratégique","scientific":"Conseil médical & scientifique"},"en":{"title":"Peptinov team","management":"Management","rd":"R&D team","strategic":"Strategic board","scientific":"Medical and scientific board"}}')
  delete Component.options._Ctor
}
